// extracted by mini-css-extract-plugin
export default {"light-background":"styles_light-background__4W1JR"};